<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile">
                <div class="first-container-mobile">
                    <div class="first-block">
                        <div class="logo-container-footer">
                            <img src="../assets/img/chivas-footer-logo.svg" alt="logo" class="jameson-logo-mobile" />
                        </div>
                        <p class="title-first-block-mobile">
                            <span v-for="(line, i) in config.titleSecondary" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <!-- <img :src="config.logoMain" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoInvisible" alt="jameson" class="jameson-invisible" /> -->
                        <p class="description-first-block-mobile">
                            <span v-for="(line, i) in config.descriptionSecondary" :key="i"
                                :class="{ 'with-padding': i === 1 || i === 2 }">
                                <template v-if="i === 0">
                                    <span class="brand-bold"></span>
                                    {{ line.replace('Chivas Regal Crystalgold', '') }}
                                </template>

                                <template v-else>
                                    {{ line }}
                                </template>

                                <br v-if="i < config.description.length - 1">
                            </span>
                        </p>


                        <!-- <div class="logo-container-footer mb-5">
                            <img src="../assets/img/chivas-crytal-bottle-mobile.png" alt="logo"
                                class="big-img-first-block-mobile" />
                        </div> -->
                        <!-- <p class="description-first-block-small-mobile">
                            <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span>
                        </p> -->
                    </div>
                    <!-- <div class="second-block">
                                <img :src="config.bigImage" alt="jameson" class="big-img-first-block" />
                            </div> -->
                </div>

                <!-- <div class="second-contaier second-contaier-mobile"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecondMobile)})` }">
                    <div class="second-first-container-mobile">
                        <div class="second-first-block-mobile">
                            <p class="second-block-title-mobile">{{ config.titleCond }}</p>
                            <p class="second-block-description-mobile">
                                <span>{{ config.secondTitleCond }}</span>
                            </p>
                        </div>
                        <div class="second-second-block-mobile">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container">
                                <p class="number-mobile">{{ index + 1 }}.</p>
                                <p class="condition-text-mobile"><span v-html="cond"></span></p>
                            </div>
                        </div>

                    </div>
                </div> -->

                <div class="third-container-mobile">
                    <div class="registration-body-container-mobile">
                        <div class="title-container">
                            <p class="text-title-mobile">ЗАРЕГИСТРИРУЙТЕСЬ</p>
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#ffffff" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit-mobile mt-10 mb-10" @click="getFormFields">Повторить
                                попытку</button>
                        </div>
                        <div v-else class="form-main-mobile">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <!-- input text/email/etc -->
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body-mobile"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question, true)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body-mobile"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @input="validateField(question)" />
                                    <div class="error-message" v-if="![5, 6, 9].includes(question.type)">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                                <!-- select -->
                                <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                    :items="question.answers" item-text="name" item-value="id" dense outlined
                                    hide-details :placeholder="getPlaceholder(question,true)" class="mb-3 pt-1">
                                    <template v-slot:selection="{ item }">
                                        <div v-if="item" style="white-space: normal; word-break: break-word;">
                                            {{ item.name }}
                                        </div>
                                        <span v-else class="truncate-text">
                                            {{ getPlaceholder(question) }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                            <div class="btn-container mt-6">
                                <div v-for="question in filteredQuestions" :key="question.id"
                                    class="checkbox-container">

                                    <div class="checkbox-content">
                                        <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                            :id="question.id" @change="markTouched(question)"
                                            @input="validateField(question)" />

                                        <label class="checkbox-label" :for="question.id">
                                            <!-- если это согласие на обработку персональных данных -->
                                            <template v-if="question.number === 6 || question.number === 9">
                                                Я даю согласие на
                                                <a class="policy-link"
                                                    @click.stop.prevent="openPopup('offer')">
                                                    сбор и обработку персональных данных
                                                </a>
                                            </template>

                                            <!-- для всех остальных чекбоксов -->
                                            <template v-else>
                                                {{ question.name }}
                                            </template>
                                        </label>
                                    </div>

                                </div>
                                <button @click="confirmRegistration" class="btn-form-submit-mobile mt-10 mb-10"
                                    :disabled="isSendSms">{{
                                        isSendSms ?
                                            "Отправка..." : "Зарегистрироваться" }}</button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="main-container-footer-mobile">


                    <div class="footer-container-mobile">
                        <div class="politics-container-mobile">
                            <div class="logo-container-footer">
                                <img src="../assets/img/сhivas-footer-logo-mobile.svg" alt=""
                                    class="jameson-logo-footer-mobile" />
                            </div>
                            <div class="d-flex flex-column-reverse">
                                <div class="footer-first-block">
                                    <p class="link-text-mobile pb-5" style="color: #fff!important;">{{ config.footer.warningText }}</p>
                                    <a class="link-text-mobile" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <!-- <div class="logo-container-footer-2">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" />
                                </div> -->
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text }}</a>
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div class="social-container-mobile">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo"> -->
                            </div>
                            <div class="social-icons-container">
                                <div @click="goTo('https://www.instagram.com/chivas_kz?igsh=b3hiazd2NmVmbTRw')">
                                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                         <circle cx="25" cy="25" r="24.5" stroke="#EBB970" />
                                        <path
                                            d="M35.5741 20.3383C35.5234 19.19 35.3377 18.4005 35.0717 17.7164C34.7973 16.9903 34.3751 16.3402 33.822 15.7998C33.2816 15.2509 32.6272 14.8245 31.9095 14.5543C31.2214 14.2883 30.4361 14.1026 29.2878 14.052C28.1309 13.9971 27.7636 13.9844 24.8294 13.9844C21.8952 13.9844 21.528 13.9971 20.3754 14.0477C19.2271 14.0983 18.4376 14.2842 17.7537 14.55C17.0274 14.8245 16.3773 15.2466 15.8369 15.7998C15.288 16.3402 14.8617 16.9946 14.5914 17.7123C14.3254 18.4005 14.1397 19.1857 14.0891 20.334C14.0342 21.4909 14.0215 21.8581 14.0215 24.7923C14.0215 27.7265 14.0342 28.0938 14.0848 29.2464C14.1354 30.3947 14.3213 31.1842 14.5873 31.8682C14.8617 32.5944 15.288 33.2445 15.8369 33.7849C16.3773 34.3337 17.0317 34.7602 17.7494 35.0303C18.4376 35.2964 19.2228 35.4821 20.3713 35.5327C21.5237 35.5835 21.8911 35.596 24.8253 35.596C27.7595 35.596 28.1268 35.5835 29.2794 35.5327C30.4277 35.4821 31.2171 35.2964 31.9011 35.0303C33.3535 34.4688 34.5018 33.3205 35.0633 31.8682C35.3292 31.18 35.515 30.3947 35.5657 29.2464C35.6163 28.0938 35.629 27.7265 35.629 24.7923C35.629 21.8581 35.6247 21.4909 35.5741 20.3383ZM33.6279 29.162C33.5814 30.2174 33.4041 30.7874 33.2563 31.1673C32.8932 32.1089 32.146 32.8561 31.2044 33.2192C30.8245 33.367 30.2504 33.5443 29.1991 33.5906C28.0592 33.6414 27.7173 33.654 24.8337 33.654C21.9502 33.654 21.604 33.6414 20.4682 33.5906C19.4128 33.5443 18.8428 33.367 18.4628 33.2192C17.9943 33.0461 17.5678 32.7717 17.2217 32.4128C16.8628 32.0623 16.5884 31.6402 16.4152 31.1716C16.2675 30.7917 16.0902 30.2174 16.0439 29.1662C15.9931 28.0263 15.9805 27.6843 15.9805 24.8007C15.9805 21.9172 15.9931 21.571 16.0439 20.4354C16.0902 19.3799 16.2675 18.81 16.4152 18.43C16.5884 17.9613 16.8628 17.535 17.226 17.1887C17.5763 16.8298 17.9984 16.5554 18.4671 16.3824C18.8471 16.2347 19.4213 16.0574 20.4725 16.0109C21.6124 15.9602 21.9545 15.9475 24.8379 15.9475C27.7257 15.9475 28.0676 15.9602 29.2034 16.0109C30.2588 16.0574 30.8288 16.2347 31.2087 16.3824C31.6773 16.5554 32.1037 16.8298 32.4499 17.1887C32.8088 17.5391 33.0832 17.9613 33.2563 18.43C33.4041 18.81 33.5814 19.3841 33.6279 20.4354C33.6785 21.5753 33.6912 21.9172 33.6912 24.8007C33.6912 27.6843 33.6785 28.0221 33.6279 29.162Z"
                                            fill="#EBB970" />
                                        <path
                                            d="M24.8291 19.24C21.7641 19.24 19.2773 21.7266 19.2773 24.7917C19.2773 27.8569 21.7641 30.3435 24.8291 30.3435C27.8942 30.3435 30.3808 27.8569 30.3808 24.7917C30.3808 21.7266 27.8942 19.24 24.8291 19.24ZM24.8291 28.393C22.8407 28.393 21.2278 26.7803 21.2278 24.7917C21.2278 22.8032 22.8407 21.1905 24.8291 21.1905C26.8176 21.1905 28.4304 22.8032 28.4304 24.7917C28.4304 26.7803 26.8176 28.393 24.8291 28.393Z"
                                            fill="#EBB970" />
                                        <path
                                            d="M31.897 19.0207C31.897 19.7364 31.3167 20.3168 30.6008 20.3168C29.885 20.3168 29.3047 19.7364 29.3047 19.0207C29.3047 18.3048 29.885 17.7246 30.6008 17.7246C31.3167 17.7246 31.897 18.3048 31.897 19.0207Z"
                                            fill="#EBB970" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
            </div>
            <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
                @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                :errorMessage="otpError" :loading="otpVerifying" />
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container">
                <div class="first-container">
                    <div class="first-block">
                        <img src="../assets/img/chivas-footer-logo.svg" alt="logo" class="jameson-logo" />
                        <p class="title-first-block">
                            <span v-for="(line, i) in config.titleSecondary" :key="i">
                                {{ line }}
                                <br v-if="i < config.titleSecondary.length - 1">
                            </span>
                        </p>
                        <!-- <img src="../assets/img/jameson-logo-age-confirm.png" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoMain" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoInvisible" alt="jameson" class="jameson-invisible" /> -->
                        <!-- <img src="../assets/img/j-invicible.png" alt="logo" class="jameson-invisible" /> -->
                        <p class="description-first-block">
                            <span v-for="(line, i) in config.descriptionSecondary" :key="i"
                                :class="{ 'with-padding': i === 1 || i === 2 }">
                                <template v-if="i === 0">
                                    <span class="brand-bold"></span>
                                    {{ line.replace('Chivas Regal Crystalgold', '') }}
                                </template>

                                <template v-else>
                                    {{ line }}
                                </template>

                                <br v-if="i < config.descriptionSecondary.length - 1">
                            </span>
                        </p>
                        <!-- <p class="description-first-block-small">
                            <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span>
                        </p> -->
                    </div>
                    <!-- <div class="second-block">
                        <img src="../assets/img/chivas-crystalgold-first.png" alt="logo" class="big-img-first-block" />
                    </div> -->
                </div>

                <!-- <div class="second-contaier"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecond)})` }">
                    <div class="second-first-container">
                        <div class="second-first-block">
                            <p class="second-block-title">{{ config.titleCond }}</p>
                            <p class="second-block-description">
                                <span>{{ config.secondTitleCond }}</span>
                            </p>
                        </div>
                        <div class="second-second-block">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container">
                                <p class="number">{{ index + 1 }}.</p>
                                <p class="condition-text"><span v-html="cond"></span></p>
                            </div>

                        </div>

                    </div>
                </div> -->

                <div class="third-container">
                    <div class="registration-body-container">
                        <div class="title-container">
                            <p class="text-title">ЗАРЕГИСТРИРУЙТЕСЬ</p>
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#ffffff" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                                попытку</button>
                        </div>
                        <div v-else class="form-main">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <label>{{ question.name }}</label>
                                <div class="input-wrapper">
                                    <!-- input text/email/etc -->
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                    <!-- select -->
                                    <v-select v-else-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                        :items="question.answers" item-text="name" item-value="id" dense outlined
                                        hide-details :placeholder="getPlaceholder(question)" class="my-select">
                                        <template v-slot:selection="{ item }">
                                            <div class="select-input" style="white-space: normal; word-break: break-word;">
                                                {{ item.name }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="error-message">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!formError" class="btn-container mt-6 mb-5">
                            <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container">
                                <div class="checkbox-content">
                                    <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                        :id="question.id" @change="markTouched(question)"
                                        @input="validateField(question)" />

                                    <label class="checkbox-label" :for="question.id">
                                        <!-- если это согласие на обработку персональных данных -->
                                        <template v-if="question.number === 6">
                                            Я даю согласие на
                                            <a class="policy-link"
                                                @click.stop.prevent="openPopup('offer')">
                                                сбор и обработку персональных данных
                                            </a>
                                        </template>

                                        <!-- для всех остальных чекбоксов -->
                                        <template v-else>
                                            {{ question.name }}
                                        </template>
                                    </label>
                                </div>
                            </div>
                            <button @click="confirmRegistration" class="btn-form-submit mt-8 mb-10"
                                :disabled="isSendSms">{{
                                    isSendSms ? "Отправка..." : "Зарегистрироваться" }}</button>

                        </div>
                    </div>

                </div>
                <div class="main-container-footer">


                    <div class="footer-container">
                        <div class="politics-container">
                            <div>
                                <img src="../assets/img/chivas-footer-logo.svg" alt="" class="jameson-logo-footer" />
                            </div>
                            <div class="d-flex mt-7">
                                <div class="footer-first-block">
                                    <p class="link-text pb-5" style="color: #fff !important;">{{ config.footer.warningText }}</p>
                                    <a class="link-text" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text
                                        }}</a>
                                    </p>
                                </div>
                            </div>
                            <!-- <button @click="openPopup('policy')">Политика конфиденциальности</button>
                            <button @click="openPopup('offer')">Оферта</button>
                            <button @click="openPopup('rules')">Правила</button> -->
                        </div>
                        <div class="social-container">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" /> -->
                            </div>
                            <div class="social-icons-container">
                                <!-- <div class="" @click="goTo('https://www.facebook.com/ChivasRegalKazakhstan')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                        <path
                                            d="M37.0742 18.1049C37.0742 16.2331 35.4227 14.5815 33.5509 14.5815H19.3475C17.4758 14.5815 15.8242 16.2331 15.8242 18.1049V32.3082C15.8242 34.18 17.4758 35.8315 19.3475 35.8315H26.5043V27.794H23.8618V24.2707H26.5043V22.8393C26.5043 20.417 28.2659 18.3251 30.468 18.3251H33.3307V21.8484H30.468C30.1377 21.8484 29.8074 22.1787 29.8074 22.8393V24.2707H33.3307V27.794H29.8074V35.8315H33.5509C35.4227 35.8315 37.0742 34.18 37.0742 32.3082V18.1049Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                                <div @click="goTo('https://www.instagram.com/chivas_kz?igsh=b3hiazd2NmVmbTRw')">
                                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                         <circle cx="25" cy="25" r="24.5" stroke="#EBB970" />
                                        <path
                                            d="M35.5741 20.3383C35.5234 19.19 35.3377 18.4005 35.0717 17.7164C34.7973 16.9903 34.3751 16.3402 33.822 15.7998C33.2816 15.2509 32.6272 14.8245 31.9095 14.5543C31.2214 14.2883 30.4361 14.1026 29.2878 14.052C28.1309 13.9971 27.7636 13.9844 24.8294 13.9844C21.8952 13.9844 21.528 13.9971 20.3754 14.0477C19.2271 14.0983 18.4376 14.2842 17.7537 14.55C17.0274 14.8245 16.3773 15.2466 15.8369 15.7998C15.288 16.3402 14.8617 16.9946 14.5914 17.7123C14.3254 18.4005 14.1397 19.1857 14.0891 20.334C14.0342 21.4909 14.0215 21.8581 14.0215 24.7923C14.0215 27.7265 14.0342 28.0938 14.0848 29.2464C14.1354 30.3947 14.3213 31.1842 14.5873 31.8682C14.8617 32.5944 15.288 33.2445 15.8369 33.7849C16.3773 34.3337 17.0317 34.7602 17.7494 35.0303C18.4376 35.2964 19.2228 35.4821 20.3713 35.5327C21.5237 35.5835 21.8911 35.596 24.8253 35.596C27.7595 35.596 28.1268 35.5835 29.2794 35.5327C30.4277 35.4821 31.2171 35.2964 31.9011 35.0303C33.3535 34.4688 34.5018 33.3205 35.0633 31.8682C35.3292 31.18 35.515 30.3947 35.5657 29.2464C35.6163 28.0938 35.629 27.7265 35.629 24.7923C35.629 21.8581 35.6247 21.4909 35.5741 20.3383ZM33.6279 29.162C33.5814 30.2174 33.4041 30.7874 33.2563 31.1673C32.8932 32.1089 32.146 32.8561 31.2044 33.2192C30.8245 33.367 30.2504 33.5443 29.1991 33.5906C28.0592 33.6414 27.7173 33.654 24.8337 33.654C21.9502 33.654 21.604 33.6414 20.4682 33.5906C19.4128 33.5443 18.8428 33.367 18.4628 33.2192C17.9943 33.0461 17.5678 32.7717 17.2217 32.4128C16.8628 32.0623 16.5884 31.6402 16.4152 31.1716C16.2675 30.7917 16.0902 30.2174 16.0439 29.1662C15.9931 28.0263 15.9805 27.6843 15.9805 24.8007C15.9805 21.9172 15.9931 21.571 16.0439 20.4354C16.0902 19.3799 16.2675 18.81 16.4152 18.43C16.5884 17.9613 16.8628 17.535 17.226 17.1887C17.5763 16.8298 17.9984 16.5554 18.4671 16.3824C18.8471 16.2347 19.4213 16.0574 20.4725 16.0109C21.6124 15.9602 21.9545 15.9475 24.8379 15.9475C27.7257 15.9475 28.0676 15.9602 29.2034 16.0109C30.2588 16.0574 30.8288 16.2347 31.2087 16.3824C31.6773 16.5554 32.1037 16.8298 32.4499 17.1887C32.8088 17.5391 33.0832 17.9613 33.2563 18.43C33.4041 18.81 33.5814 19.3841 33.6279 20.4354C33.6785 21.5753 33.6912 21.9172 33.6912 24.8007C33.6912 27.6843 33.6785 28.0221 33.6279 29.162Z"
                                            fill="#EBB970" />
                                        <path
                                            d="M24.8291 19.24C21.7641 19.24 19.2773 21.7266 19.2773 24.7917C19.2773 27.8569 21.7641 30.3435 24.8291 30.3435C27.8942 30.3435 30.3808 27.8569 30.3808 24.7917C30.3808 21.7266 27.8942 19.24 24.8291 19.24ZM24.8291 28.393C22.8407 28.393 21.2278 26.7803 21.2278 24.7917C21.2278 22.8032 22.8407 21.1905 24.8291 21.1905C26.8176 21.1905 28.4304 22.8032 28.4304 24.7917C28.4304 26.7803 26.8176 28.393 24.8291 28.393Z"
                                            fill="#EBB970" />
                                        <path
                                            d="M31.897 19.0207C31.897 19.7364 31.3167 20.3168 30.6008 20.3168C29.885 20.3168 29.3047 19.7364 29.3047 19.0207C29.3047 18.3048 29.885 17.7246 30.6008 17.7246C31.3167 17.7246 31.897 18.3048 31.897 19.0207Z"
                                            fill="#EBB970" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
                <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
                    @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                    :errorMessage="otpError" :loading="otpVerifying" />

            </div>


        </div>
        <ConfirmAge1 v-if="showConfirm" @confirmed="onConfirmed" />
        <transition name="popup">
            <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <div class="popup-header">
                        <span class="header-text">{{ popupTexts[currentPopup].title }}</span>
                        <span class="popup-close-1" @click="closePopup"><svg width="21" height="21" viewBox="0 0 40 40"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.07373 33.4784C-0.348236 34.8712 -0.377256 37.4247 1.10275 38.9046C2.58275 40.3845 5.13648 40.3264 6.52942 38.9336L19.9945 25.4697L33.4597 38.9046C34.9106 40.3555 37.4063 40.3845 38.8863 38.8756C40.3663 37.3957 40.3663 34.9003 38.9154 33.4494L25.4793 20.0145L38.9154 6.5506C40.3663 5.09975 40.3663 2.60428 38.8863 1.12441C37.4063 -0.384476 34.9106 -0.355459 33.4597 1.09539L19.9945 14.5303L6.52942 1.06638C5.13648 -0.326442 2.58275 -0.384476 1.10275 1.09539C-0.377256 2.57526 -0.348236 5.12876 1.07373 6.5506L14.5388 20.0145L1.07373 33.4784Z"
                                    fill="white" />
                            </svg></span>
                    </div>
                    <div class="popup-text-1" v-html="popupTexts[currentPopup].content"></div>
                </div>
            </div>
        </transition>

        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>


</template>


<style scoped>
.jameson-logo-footer-mobile {
    width: 169px;
    height: 188px;
}

.with-padding {
    display: block;
    /* чтобы padding сработал корректно */
    margin-top: 25px;
}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 5px;
    color: var(--color-white);
    font-size: 16px;
    font-family: var(--font-family-regular);
    display: flex;
    flex-direction: row;
    font-weight: 400;
}

input:focus {
    outline: 1px solid #1976d2;
    box-shadow: 0 0 5px #1976d2;
}

.popup-header {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-content {
    background-color: var(--color-primary);
    background-size: cover;
    background-position: center;
    padding: 20px;
    width: 100%;
    max-width: 1150px;
    border-radius: 10px;
    /* max-height: 897px; */
    height: 100%;
    max-height: 80vh;
    /* ограничение всей области */
    display: flex;
    flex-direction: column;

}

:deep(.chivas-link) {
    color: var(--color-white);
    font-weight: 700;
    text-decoration: underline;
    transition: color 0.2s;
}

:deep(.chivas-link:hover) {
    color: var(--color-white);
    text-decoration: underline;
}

.condition-container {
    border-top: 2px solid var(--color-white);
    /* border-bottom: 2px solid #141097; */
}

.second-second-block .condition-container:last-child {
    border-bottom: 2px solid var(--color-white);
}

/* .second-second-block .condition-container:nth-child(-n+3) {
    border-bottom: none;
} */


.condition-text {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: var(--font-family);
}

.condition-text span {
    font-weight: 400;
    font-size: 32px;
    color: var(--color-white);
    margin-bottom: 0px;
    font-family: var(--font-family);
    text-decoration: none;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
}

.error-message {
    color: red;
    font-weight: 300;
    font-size: 14px;
    font-family: var(--font-family-bold);
    min-height: 18px;
}

.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    max-width: 666px;


}

.form-loading {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-error-text {
    font-weight: 400;
    font-size: 16px;
    color: #ad0202;
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}



.btn-form-submit,
.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    background:linear-gradient(90deg, #f6c16e 0%, #854e16 100%) !important;
    /* background-size: 200% 200% !important;
    background-position: 0% 50% !important; */
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    color: #000000 !important;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(133, 78, 22, 0.35) !important;
    transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* При наведении */
.btn-form-submit:hover,
.btn-form-submit-mobile:hover {
    background-position: 100% 50% !important;
    transform: translateY(-2px) scale(1.015);
    box-shadow: 0 8px 25px rgba(246, 193, 110, 0.45), 0 3px 8px rgba(0, 0, 0, 0.2) !important;
    color: #000000 !important;
    filter: brightness(1.08);
}

/* При нажатии */
.btn-form-submit:active,
.btn-form-submit-mobile:active {
    background-position: 50% 50% !important;
    transform: translateY(1px) scale(0.98);
    box-shadow: 0 2px 8px rgba(133, 78, 22, 0.4) !important;
    filter: brightness(0.95);
    transition: all 0.1s ease !important;
}

.btn-form-submit-mobile {
    border-radius: 8px;
    padding: 11px 32px;
    width: 100%;
    max-width: 325px;
    height: 48px;
    font-size: 16px;
    margin: 16px auto 0 auto;
}

.position-relative {
    position: relative;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}



.popup-container {
    background: #154734;
    padding: 20px;
    text-align: center;
    position: relative;
    border-radius: 30px;
    width: 594px;
    height: 421px;
}

.popup-close {
    position: absolute;
    top: 25px;
    right: 27px;
    background: none;
    border: none;
    color: #f2e4b5;
    cursor: pointer;
}

.popup-logo {
    width: auto;
    height: auto;
    margin-bottom: 38px;
    margin-top: 10px;
}

.popup-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #f2e4b5;
    margin-bottom: 31px;
}

.popup-text {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 36px;
    text-align: center;
    color: #f2e4b5;
    max-width: 346px;
    width: 100%;
    margin-bottom: 0px;
    line-height: 1.2;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}

.social-icons-container {
    cursor: pointer;
}

.social-icons-container svg {
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease;
}

.social-icons-container svg:hover {
    transform: scale(1.1);
}

.social-icons-container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
}

.j-logo-footer {
    width: 118px;
    height: 155px;
}

.politics-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 253px;
}

.main-container-footer {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-top: clamp(40px, 6.76vh, 73px);
    padding-bottom: clamp(40px, 7.5vh, 101px);
    background-color: var(--color-primary);

}

.footer-j-logo {
    text-align: center;
}

.social-container {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    /* margin-top: auto; */

    height: 242px;
}

.footer-main-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: clamp(var(--font-size-xs), 2.5vw, var(--font-size-md));
    line-height: 175%;
    color: var(--color-primary-1);
    margin-bottom: 0;
    text-decoration: none;
}

.link-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-primary-1);
    margin-bottom: 0px;
}

.footer-first-block {
    max-width: clamp(240px, 28.04vw, 476px);
    margin-right: clamp(20px, 3.13vw, 60px);
    /* margin-top: 36px; */
}

.footer-container {

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.jameson-logo-footer {
    width: 458px;
    height: 102px;
}

.btn-green {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: #141097;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f2e4b5;
}

.checkbox {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    background-color: white;
    margin-right: 6px;
}

.checkbox-mobile {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    background-color: white;
    margin-left: 20px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    flex-direction: column;
}

.checkbox-container label {
    color: white;
    font-family: var(--font-family-regular);
}

.checkbox-container router-link {
    color: white;
}

.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Desktop third-container Form Styles (matching form-1.png) */
.third-container {
    position: relative;
    /* background-image: url('../assets/img/chivas-form-main-bg.png');
    background-size: cover;
    background-position: center center; */
    background-color: #000000;
    min-height: 800px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
}

.third-container .registration-body-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 960px;
    width: 100%;
    margin: 0 auto;
}

.third-container .title-container {
    padding-top: 0;
    padding-bottom: 36px;
    width: 100%;
    text-align: center;
}

.third-container .text-title {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 80px;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary-1);
    margin-bottom: 0;
    line-height: 1.2;
    letter-spacing: 0.5px;
}

.third-container .form-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    width: 100%;
    max-width: 740px;
    margin: 0 auto;
}

.third-container .form-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 20px;
}

.third-container .form-container label {
    color: var(--color-white);
    font-size: 24px;
    font-weight: 400;
    margin-right: 0;
    text-align: left;
    font-family: var(--font-family);
    flex: 1;
    max-width: 280px;
    line-height: 1.3;
    padding-bottom: 0;
}

.third-container .input-wrapper {
    width: 460px;
    flex: 0 0 460px;
    display: flex;
    flex-direction: column;
}

.third-container .input-body {
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: var(--color-white);
    border-radius: 8px;
    padding: 12px 16px;
    width: 100%;
    height: 52px;
    font-size: 24px;
    font-weight: 400;
    font-family: var(--font-family);
    background: transparent;
    box-sizing: border-box;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.third-container .input-body::placeholder {
    color: var(--color-white);
    font-size: 24px;
    font-family: var(--font-family);
    opacity: 1;
}

.third-container .input-body:focus {
    border-color: #FFFFFF;
    box-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
    outline: none;
}

.input-name {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 24px;
    color: var(--color-primary-light);
    margin-right: 20px;
    margin-bottom: 0px;
    white-space: nowrap;
}

/* Vuetify v-select overrides inside desktop third-container */
.third-container ::v-deep .v-select {
    margin: 0;
    padding: 0;
    width: 100%;
}

.third-container ::v-deep .v-text-field--outlined fieldset {
    border-color: rgba(255, 255, 255, 0.4) !important;
    border-radius: 8px !important;
    transition: border-color 0.2s;
}

.third-container ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: #FFFFFF !important;
}

.third-container ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 48px !important;
    height: 48px !important;
    background: transparent !important;
    padding: 0 12px !important;
    width: 100% !important;
}

.third-container ::v-deep .v-select .v-select__selection--comma,
.third-container ::v-deep .v-select .select-input {
    color: var(--color-white) !important;
    font-size: 24px !important;
    font-family: var(--font-family) !important;
}

.third-container ::v-deep .v-select input::placeholder {
    color: var(--color-white) !important;
    font-size: 24px !important;
    font-family: var(--font-family) !important;
}

.third-container ::v-deep .v-select .v-icon {
    color: #FFFFFF !important;
}

.third-container ::v-deep .v-select .v-input__append-inner {
    margin-top: 12px !important;
}

.third-container .error-message {
    color: #ff5252;
    font-weight: 400;
    font-size: 12px;
    font-family: var(--font-family-regular);
    min-height: 16px;
    margin-top: 2px;
}

/* Button & Checkbox Container */
.third-container .btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 15px auto 0 auto;
}

.third-container .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;
}

.third-container .checkbox-content {
    display: flex;
    align-items: center;
    justify-content: center;
}

.third-container .checkbox-label {
    color: #FFFFFF !important;
    font-size: 20px;
    line-height: 1.3;
    font-family: var(--font-family);
    position: relative;
    padding-left: 28px;
    cursor: pointer;
}

.third-container .checkbox-label::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 3px;
    background-color: transparent;
}

.third-container .checkbox-label::after {
    content: "";
    position: absolute;
    left: 0px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

.third-container .custom-checkbox:checked + .checkbox-label::before {
    border-color: #FFFFFF;
    background-color: transparent;
}

.third-container .custom-checkbox:checked + .checkbox-label::after {
    border-color: #FFFFFF;
}

.third-container .policy-link {
    color: #FFFFFF !important;
    text-decoration: underline !important;
    cursor: pointer;
}

.third-container .btn-form-submit {
    border-radius: 8px;
    height: 52px;
    font-size: 20px;
    margin: 10px auto 0 auto;
}

.second-first-block {
    padding-top: 94px;
}

.number {
    color: var(--color-primary-1);
    font-size: 96px;
    font-weight: 700;
    margin-bottom: 0px;
    font-family: var(--font-family-bold);
}

.second-block-description span {
    color: var(--color-primary-1);
    font-weight: 700;
    font-size: 36px;
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    text-transform: uppercase;
    font-family: var(--font-family-bold);
}

.second-first-container {
    margin: 0px 183px 0px;
}

.second-block-title {
    color: var(--color-primary-1);
    font-weight: 700;
    font-size: 80px;
    text-transform: uppercase;
    margin-bottom: 0px;
    font-family: var(--font-family-bold);

}

.second-second-block {
    padding-bottom: 5.1979166667vw;
    max-width: 1075px;
}

.second-contaier {
    /* background-image:
        var(--bg-url);
    background-size: cover;
    background-position: center; */
    background-color: var(--color-primary);
    height: 100%;
}

.big-img-first-block {
    max-width: 601px;
    max-height: 831px;
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
    /* transform: rotate(-7deg); */
}

.brand-bold {
    font-weight: 900;
}

.description-first-block {
    color: var(--color-white);
    margin-top: 24px;
    /* max-width: 688px; */
    max-width: 1023px;
    font-weight: 400;
    font-size: 58px;
    line-height: 109%;
    text-transform: uppercase;
    text-align: center;
    color: #fff;
    font-family: var(--font-family-regular);
}

.description-first-block-small {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-white);
    line-height: 1.2;
    margin-top: 24px;
    max-width: 688px;
    font-family: var(--font-family-medium);
}

.title-first-block span {
    text-transform: uppercase;
}

.title-first-block {
    color: var(--color-white);
    font-weight: 700;
    font-size: 64px;
    line-height: 125%;
    /* letter-spacing: 0.07em; */
    text-transform: uppercase;
    text-align: center;
    margin-top: 19.94px;
    font-family: var(--font-family-bold);
    max-width: 1444px;
}

.first-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* padding: 100px 183.66px 127.15px 182px; */

}

.jameson-invisible {
    width: 131px;
    height: 172px;
    margin-left: 54.04px;
}

.jameson-logo {
    margin-top: 17px;
    width: 996px;
    height: 146px;
    margin-bottom: 17px;
}

.first-container {
    background-image: url('../assets/img/chivas-main-bg.jpg');
    background-size: cover;
    background-position: bottom;
    height: 100vh;
    /* padding: 86px 183.66px 127.15px 182px; */
    /* padding: 100px 183.66px 127.15px 182px; */
    display: flex;
    justify-content: center;
    align-items: center;
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}



input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

.header-text {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 30px;
    text-transform: uppercase;
    color: #FFFFFF;
}

.popup-close-1 {
    /* font-size: 20px; */
    cursor: pointer;
}

.popup-text-1 {
    font-family: var(--font-family-regular);
    font-weight: 400;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 1.6;
    white-space: pre-line;
    padding: 0 15px;
    overflow-y: auto;
    /* скролл только текста */
    flex: 1;
}

.popup-text-1::-webkit-scrollbar {
    width: 8px;
    /* толщина */
}

/* Ползунок */
.popup-text-1::-webkit-scrollbar-thumb {
    background-color: white;
    /* цвет (как на картинке) */
    border-radius: 10px;
    /* закругления */
}

/* Фон скроллбара */
.popup-text-1::-webkit-scrollbar-track {
    background: transparent;
    /* прозрачный трек */
}

.popup-close {
    margin-top: 10px;
    align-self: flex-end;
}

.custom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* стили для label */
.checkbox-label {
    /* display: flex;
  align-items: flex-start; */
    cursor: pointer;
    font-size: 20px;
    line-height: 1.3;
    font-family: var(--font-family-regular);
    font-weight: 400;
    /* твой кастомный шрифт */
    position: relative;
    padding-left: 24px;
    /* отступ под квадратик */
}

/* кастомный квадратик */
.checkbox-label::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 1px solid #3F1405;
    border-radius: 2px;
    /* убери, если нужен квадрат без скруглений */
    background-color: transparent;
}

.checkbox-label::after {
    content: "";
    position: absolute;
    left: 0px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    /* по умолчанию невидимая */
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

/* при checked — черный фон и белая галочка */
.custom-checkbox:checked+.checkbox-label::before {
    background-color: transparent;
}

.custom-checkbox:checked+.checkbox-label::after {
    border-color: #000000;
    /* галочка черная */
}

/* ---------------------------------------MOBILE */

/* Mobile third-container-mobile Form Styles (matching desktop color scheme, no labels) */
.third-container-mobile {
    position: relative;
    background-color: var(--color-primary);
    height: 100%;
    padding: 40px 16px 40px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.third-container-mobile .registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.third-container-mobile .form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
}

.third-container-mobile .form-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.third-container-mobile .form-container > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.third-container-mobile .text-title-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 28px;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary-1);
    margin-bottom: 24px;
    line-height: 1.2;
}

.third-container-mobile .input-body-mobile {
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 8px;
    padding: 12px 14px;
    width: 100%;
    max-width: 360px;
    height: 48px;
    font-size: 18px;
    color: var(--color-white);
    background: transparent;
    font-family: var(--font-family);
    font-weight: 400;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.third-container-mobile .input-body-mobile::placeholder {
    color: rgba(255, 255, 255, 0.7);
    font-size: 18px;
    font-family: var(--font-family);
    opacity: 1;
    font-weight: 400;
}

.third-container-mobile .input-body-mobile:focus {
    border-color: #FFFFFF;
    box-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
}

/* Vuetify v-select overrides inside mobile third-container-mobile */
.third-container-mobile ::v-deep .v-select {
    margin: 0;
    padding: 0;
    width: 100% !important;
    max-width: 360px !important;
}

.third-container-mobile ::v-deep .v-text-field--outlined fieldset {
    border-color: rgba(255, 255, 255, 0.4) !important;
    border-radius: 8px !important;
}

.third-container-mobile ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: #FFFFFF !important;
}

.third-container-mobile ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 48px !important;
    height: 48px !important;
    background: transparent !important;
    padding: 0 12px !important;
    width: 100% !important;
}

.third-container-mobile ::v-deep .v-select .v-select__selection--comma,
.third-container-mobile ::v-deep .v-select .truncate-text,
.third-container-mobile ::v-deep .v-select input {
    color: #FFFFFF !important;
    font-size: 18px !important;
    font-family: var(--font-family) !important;
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 18px !important;
    font-family: var(--font-family) !important;
}

.third-container-mobile ::v-deep .v-select .v-icon {
    color: #FFFFFF !important;
}

.third-container-mobile .btn-container {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 0;
    margin-top: 15px;
}

.third-container-mobile .checkbox-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.third-container-mobile .checkbox-label {
    color: #FFFFFF !important;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.4;
    font-family: var(--font-family);
    position: relative;
    padding-left: 28px;
    cursor: pointer;
}

.third-container-mobile .checkbox-label::before {
    content: "";
    position: absolute;
    left: 0;
    top: 5px;
    width: 20px;
    height: 20px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 3px;
    background-color: transparent;
}

.third-container-mobile .checkbox-label::after {
    content: "";
    position: absolute;
    left: 6px;
    top: 7px;
    width: 7px;
    height: 10px;
    border: solid transparent;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

.third-container-mobile .custom-checkbox:checked + .checkbox-label::before {
    border-color: #FFFFFF;
    background-color: transparent;
}

.third-container-mobile .custom-checkbox:checked + .checkbox-label::after {
    border-color: #FFFFFF;
}

.third-container-mobile .policy-link {
    color: #FFFFFF !important;
    text-decoration: underline !important;
    cursor: pointer;
}

.second-block-title-mobile {
    color: var(--color-primary-1);
    font-weight: 700;
    font-size: 30px;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: left;
    font-family: var(--font-family-bold);
}

.second-block-description-mobile span {
    font-family: var(--font-family-bold);
    color: var(--color-primary-1);
    font-weight: 700;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    line-height: 28px;
    text-transform: uppercase;
    text-align: left;
}

.second-first-container-mobile {
    margin: 0px 15px 0px;
}

.number-mobile {
    color: var(--color-primary-1);
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 0px;
    font-family: var(--font-family-bold);
}

.condition-text-mobile {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 10px;
    font-family: var(--font-family)
}

.condition-text-mobile span {
    font-weight: 400;
    font-size: 16px;
    color: var(--color-white);
    margin: 25px 0;
    font-family: var(--font-family);
}

.text-title-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 33px;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-white);
    margin-bottom: 0;
    line-height: 1.2;
    word-wrap: break-word;
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}

.footer-container-mobile {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}

.no-truncate .v-select__selection {
    white-space: normal !important;
    text-overflow: initial !important;
    overflow: visible !important;
}


.first-block-logo-mobile {
    max-width: 320.11px;
    height: 47.02px;
    width: 100%;
    margin-bottom: 5.94px;
}

.first-container-mobile {
    background-image: url('../assets/img/chivas-bg-mobile.png');
    background-size: cover;
    background-position: center;
    height: 80vh;
    /* padding: 0 30px; */
    display: flex;
    justify-content: center;
    align-items: center;
}

.second-first-block-mobile {
    padding-top: 32px;
}

.second-second-block-mobile {
    padding-bottom: 25px;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
    max-width: 520px;
}

.logo-container-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    width: 100%;
    /* height: 200px; */
}

.logo-container-footer-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 46px;
}

.link-text-mobile {
    font-weight: 400;
    font-size: 14px;
    color: var(--color-primary-1);
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.politics-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.social-container-mobile {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    margin-top: 47px;
}

.main-container-footer-mobile {
    padding: 50px 15px;
    background-color: var(--color-primary);

}



.title-first-block-mobile {
    color: var(--color-white);
    font-weight: 700;
    font-size: 30px;
    line-height: 1.2;
    /* margin-top: 24.08px; */
    font-family: var(--font-family-bold);
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 27px;
    padding: 0 15px;
}

.description-first-block-mobile {
    color: var(--color-white);
    font-weight: 400;
    font-size: var(--font-size-lg);
    line-height: 1.2;
    margin-top: 18px;
    max-width: 360px;
    font-family: var(--font-family);
    text-align: center;
    text-transform: uppercase;
    margin: auto;
    margin-bottom: 43px;
    padding: 0 7.5px;
}

.description-first-block-small-mobile {
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 30px;
    max-width: 360px;
    font-family: var(--font-family-regular);
    margin: auto;
    padding: 0 7.5px;

}

.jameson-logo-mobile {
    width: 320px;
    height: 47px;
    /* margin-bottom: 18px; */
}

.big-img-first-block-mobile {
    /* max-width: 260px;
    max-height: 390px; */

    width: 100%;
    object-fit: cover;
    /* border-radius: 5px; */
}

.third-container-mobile ::v-deep .v-select__selections {
    display: flex;
    /* оставляем flex */
    align-items: center;
    flex-direction: column;
    /* выравнивание по центру */
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* ... в конце */
}

.third-container-mobile ::v-deep .v-select__selections span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

/* .third-container-mobile ::v-deep .v-select.v-input {
  width: 100% !important;
  max-width: 325px; 
} */
.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block;
    width: 100%;
}

.third-container-mobile ::v-deep .v-select input {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    display: block;
}

@media screen and (max-width: 1263px) {
    .checkbox-label {
        font-size: 16px;
    }

    /* кастомный квадратик */
    .checkbox-label::before {
        left: 0px;
        width: 15px;
        height: 15px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 3px;
    }

    .checkbox-container label {
        color: black;
        text-align: left;
        font-size: 16px;
        font-weight: 400;
    }

    .third-container {
        padding: 35px 0 0;
    }

    .popup-close-1 {
        font-size: 16px;
    }

    .title-container {
        padding-bottom: 0px;
        padding-top: 0px;
    }

    .form-container {
        justify-content: center;
        flex-direction: column;
    }

    .checkbox-container label {
        color: white;
        text-align: left;
    }

    .input-body {
        text-align: left;
    }

    .input-body-mobile {
        text-align: left;
    }

    .footer-second-block {
        margin-top: 15px;
        text-align: center;
    }

    .footer-first-block {
        text-align: center;
        width: 100%;
        margin-right: 0px;
        max-width: 440px;
        margin-top: 30px;
    }

    .footer-main-text {
        padding: 5px 0;
    }

    .first-block {
        padding: 25px 0 50px 0;
        width: 100%;
    }

    .popup-header {
        padding: 5px 0;
    }

    .header-text {
        font-family: var(--font-family-bold);
        font-weight: 700;
        font-size: 16px;
        text-transform: uppercase;
        color: #FFFFFF;
    }

    /* Текст внутри */
    .popup-text-1 {
        font-family: var(--font-family-regular);
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 1.6;
        white-space: pre-line;
        padding: 0;
        overflow-y: auto;
        /* скролл только текста */
        flex: 1;
    }

    .popup-close-1 {
        font-size: 16px;
    }
}

@media screen and (max-width: 566px) {
    /* .checkbox-label::before {
        margin-top: 10px;
    } */

    .checkbox-label::after {
        left: 5px;
        /* top: 13px; */
    }
}

@media (max-width: 1617px) and (min-width: 1262px) {
    .first-block {
        display: flex;
        flex-direction: column;
        /* padding: 50px; */
    }

    .first-container {
        /* padding-left: 120px; */


    }

    .title-first-block {
        color: var(--color-white);
        font-weight: 700;
        /* font-size: 40px; */
        font-size: 3.50416666667vw;
        line-height: 1.2;
        /* margin-top: 74.94px; */
        font-family: var(--font-family-bold);
        max-width: 1230px;
    }

    .description-first-block {
        font-size: 2.85833333333vw;
        /* max-width: 800px; */
    }

    .second-first-container {
        margin: 0 120px;
    }
}



@media screen and (max-width: 376px) {
    .form-container {
        max-width: 228px;
    }

    .additional {
        padding: 30px 20px 0px 30px;
    }

    .error-message {
        font-size: 12px;
    }

    .input-body-mobile {
        min-width: 100%;
    }

    .addition-height {
        height: 50px;
    }

    .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    /* .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        width: 100%;
        max-width: 100%;
    } */
    .input-body-mobile {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    /* .first-block {
        padding: 15px;
    } */

}

@media screen and (orientation: landscape) {
    .second-contaier-mobile {
        /* background-image: url('../assets/img/second-block-bg1.jpg');
        background-size: cover;
        background-position: center; */
        background-color: var(--color-primary);
        /* height: 100vh; */
    }


}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Otp from '@/components/otp.vue';
import ConfirmAge1 from "@/components/age-confirm.vue";
import config from "@/config/pageConfig.json";
import {
    initLanding,
    trackFormStart,
    trackFormSubmit,
    trackFormError,
    trackRegistrationSuccess,
    trackVirtualPageView
} from "@/utils/analytics";
export default {

    directives: { mask },
    name: "ChivasLounge",
    components: {
        Otp,
        ConfirmAge1
    },
    data() {
        return {
            showConfirm: true,
            isMobile: window.innerWidth < 1264,
            phone: '',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            checkbox: false,
            email: '',
            name: '',
            city: '',
            instagram: '',
            product: '',
            surname: '',
            showOtpPopup: false,
            snackbar: false,
            message: "",
            otp: '',
            expectedOtp: '1111',
            loading: false,
            smsTimer: 60, // 60 секунд
            smsTimerInterval: null,
            isSendSms: false,
            isPopupOpen: false,
            currentPopup: null,
            showPopup: false,
            formSchema: null,
            otpSuccess: false,
            otpVerifying: false,
            isLoadingForm: true,
            formError: false,
            otpError: "",
            otpErrorSms: false,
            formData: {},
            errors: {},
            touched: {},
            popupTexts: {
                policy: {
                    title: "Политика конфиденциальности",
                    content: `<b>Pernod Ricard Kazakhstan,</b> в качестве оператора персональных данных, уважает ваше
                право на конфиденциальность при использовании веб-сайта
                Цель настоящей Политики конфиденциальности — информировать вас о том, каким
                образом компания Pernod Ricard Kazakhstan собирает, хранит, использует и обрабатывает
                ваши персональные данные, предоставленные через веб-сайт (далее «Веб-сайт»).
                Темы:
                1. Какие персональные данные мы собираем?
                2. Как и зачем мы используем технологии отслеживания?
                3. С какой целью мы используем ваши персональные данные и на каком правовом
                основании?
                4. Что произойдет, если вы откажетесь предоставить свои персональные данные?
                5. Кому мы раскрываем ваши персональные данные и почему?
                6. Передаются ли ваши персональные данные за пределы Казахстана?
                7. Как долго мы храним ваши персональные данные?
                8. Как мы обеспечиваем защиту ваших персональных данных?
                9. Каковы ваши права в отношении ваших персональных данных?
                10. Как с нами связаться или подать жалобу в надзорный орган?
                11. Изменения в Политике конфиденциальности

                <b>1. Какие персональные данные мы собираем?</b>
                Мы собираем следующие персональные данные:
                -  Имя, фамилия
                - Дата рождения
                - Адрес электронной почты
                - Пароль
                - Должность
                - Название места работы
                - Фотография
                - IP-адрес
                - Интересы
                <b>Примечание:</b> IP-адрес — это последовательность чисел, используемая для
                идентификации вашего устройства при каждом подключении к интернету.

                <b>2. Как и зачем мы используем технологии отслеживания?</b>
                С вашего согласия, если это требуется по закону, наш Веб-сайт использует файлы cookie и
                подобные технологии отслеживания, такие как IP-адреса или журналы. Эти технологии
                помогают нам:
                - Лучше понимать, как посетители используют наш Веб-сайт и его функции.
                - Улучшать их функциональность.
                - Предоставлять контент, соответствующий вашим интересам.
                
                <b>Подробнее о cookies:</b> см. Политику использования файлов cookie.

                <b>3. С какой целью мы используем ваши персональные данные и на каком</b>
                правовом основании?
                <b>Pernod Ricard Kazakhstan</b> обрабатывает ваши данные в следующих целях:
                - Предоставление доступа к Веб-сайту и создание профиля пользователя.
                - Обеспечение доступа к функциям сайта (например, доступ к онлайн-контенту,
                участие в тренингах, регистрация на мероприятия).
                - Отправка административных уведомлений и сервисных сообщений.
                Мы также можем адаптировать наш контент в зависимости от ваших интересов для
                улучшения вашего опыта на сайте.
                При наличии вашего согласия данные могут использоваться для отправки маркетинговых
                сообщений.

                <b>4. Что произойдет, если вы откажетесь предоставить свои персональные
                данные?</b>
                Если вы решите не предоставлять запрашиваемые данные, вы не сможете:
                - Участвовать в некоторых активностях.
                - Пользоваться персонализированными функциями.
                - Получать специальные услуги.
                <b>Пример:</b> без адреса электронной почты вы не сможете получать наши рассылки. Однако
                вы можете просматривать сайт без предоставления данных.

                <b>5. Кому мы раскрываем ваши персональные данные и почему?</b>
                <b>В рамках группы Pernod Ricard</b>
                Ваши данные могут быть переданы аффилированным компаниям группы Pernod Ricard.
                <b>Третьи стороны</b>
                Ваши данные могут быть переданы третьим сторонам в следующих случаях:
                - <b>Техническая поддержка:</b> провайдеры, агенты или подрядчики.
                - <b>Организация мероприятий и тренингов.</b>
                - <b>По закону:</b> для защиты прав и безопасности компании или общества.
                - <b>Слияние или поглощение:</b> передача данных новому владельцу в соответствии с
                законом.

                <b>6. Передаются ли ваши персональные данные за пределы Казахстана?</b>
                Данные могут передаваться за границу с соблюдением всех необходимых мер защиты,
                включая стандартные договорные положения Европейской комиссии.

                <b>7. Как долго мы храним ваши персональные данные?</b>
                Данные хранятся:
                - Пока ваш аккаунт активен.
                - Пока это необходимо для предоставления функций сайта.
                Также данные могут храниться для выполнения правовых обязательств.

                <b>8. Как мы обеспечиваем защиту ваших персональных данных?</b>
                <b>Pernod Ricard Kazakhstan</b> принимает все необходимые меры для защиты ваших данных,
                включая:
                - Хранение данных в защищенных операционных средах.
                - Доступ к данным только у уполномоченных сотрудников и подрядчиков.

                <b>9. Каковы ваши права в отношении ваших персональных данных?</b>
                Вы имеете право:
                - Отозвать согласие на обработку данных.
                - Запросить доступ, исправление или удаление данных.
                - Ограничить обработку или запросить перенос данных.
                - Возражать против обработки.

                <b>10. Как с нами связаться или подать жалобу в надзорный орган?</b>
                По вопросам и жалобам, связанным с Политикой конфиденциальности, обращайтесь по
                адресу:
                <b>Алматы, Казахстан, Рубинштейна, 48, 050060</b>

                Или по электронной почте: <b>promo.kz@pernod-ricard.com.</b>

                <b>11. Изменения в Политике конфиденциальности</b>
                Мы регулярно обновляем нашу Политику конфиденциальности и размещаем изменения
                на этой странице.
                <b>Дата последнего обновления:</b> ноябрь 2024 года.`,
                },
                offer: {
                    title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ (для клиентов и потенциальных клиентов)",
                    content: `Я подтверждаю, что достиг возраста 21 года и более и даю <b>ТОО «Перно Рикар
                Казахстан», (БИН 050840001045),</b> а также их работникам и третьим лицам-соисполнителям по
                заключенным между ними договорам, <b>свое согласие</b> на сбор, обработку,
                распространение и трансграничную передачу (без дополнительных уведомлений)
                моих персональных данных, относящихся исключительно к перечисленным ниже
                категориям персональных данных:
                 1) ФИО
                 2) Город проживания
                 3) Мобильный телефон
                 4) E-mail
                <b>Согласованная цель сбора и обработки персональных данных</b> – пополнение CRM
                базы посредством предоставления персональных данных любыми средствами связи
                для участия в активностях, проводимых в отношении товарных знаков продукции
                ТОО «Перно Рикар Казахстан».
                Я даю согласие на использование персональных данных исключительно в
                вышеуказанных целях, а также на обработку персональных данных и их
                трансграничную передачу на всех электронных носителях, используемых для
                вышеуказанной цели.
                Настоящее согласие предоставляется мной на осуществление действий в отношении
                моих персональных данных, которые необходимы для достижения указанных выше
                целей, включая (без ограничения) сбор, систематизацию, накопление, хранение,
                уточнение (обновление, изменение), использование, передачу третьим лицам для
                осуществления действий по обмену информацией, обезличивание, блокирование
                персональных данных, трансграничную передачу персональных данных на территорию любого государства, в том числе не обеспечивающего защиту персональных данных, распространение моих персональных данных в общедоступных источниках,
                а также осуществление любых иных действий,
                предусмотренных действующим законодательством Республики Казахстан.
                Я предоставляю согласие на контактирование со мной для вышеуказанных целей путем осуществления разговора, телефонных звонков, направления мне уведомлений с использованием почты, телефона (также SMS), социальных сетей и/или мессенджеров, вебсайтов, электронной почты, электронных информационных ресурсов и иных информационных систем и мобильных приложений. 
                Я проинформирован, что вышеуказанные компании гарантируют обработку моих
                персональных данных в соответствии с действующим законодательством Республики
                Казахстан как неавтоматизированным, так и автоматизированным способами.
                Данное согласие действует в течение срока хранения информации в вышеуказанных
                целях.
                Данное согласие может быть отозвано в любой момент по моему письменному заявлению, отправленному в адрес Компании по ее юридическому адресу, зарегистрированному на дату отправки заявления или посредством направления электронного сообщения на электронную почту Компании: promo.kz@pernod-ricard.com. В случае отзыва настоящего согласия все мои Персональные данные подлежат уничтожению из базы данных Компании. 
Я подтверждаю, что для включения моих персональных данных в базу данных, в том числе партнеров указанных компаний, передачи, распространения, дополнения и прочей обработки моих персональных данных указанными компаниями с вышеупомянутой целью не требуется дополнительного уведомления меня о совершении данных действий. 

Я подтверждаю, что, давая настоящее согласие, я действую по собственной воле, в своих интересах и полностью осознаю суть и цели подписываемого документа. `,
                },
              rules: {
                    title: "УСЛОВИЯ ПРОВЕДЕНИЯ АКТИВАЦИИ CHIVAS REGAL × SCUDERIA FERRARI",
                    content: `          <b>1. Общие положения</b>

                    1.1. Настоящие Условия определяют порядок проведения активации Chivas Regal (далее — «Активация»).
                    1.2. Организатор Активации: ТОО «Pernod Ricard Kazakhstan» (далее — «Организатор»).
                    1.3. Активация проводится в целях привлечения интереса потребителей к бренду Chivas Regal, не содержит элементов риска, не требует внесения платы или покупки товара для участия и не является лотереей в понимании законодательства Республики Казахстан.
                    1.4. Регистрация участников проводится очно, в VIP-лаунже на площадке проведения концерта Энрике Иглесиаса, у представителя Организатора (далее — «Хостес»).

                    <b>2. Сроки проведения</b>

                    2.1. Активация (регистрация участников у Хостес) проводится в течение одного дня — 5 сентября 2026 года, в период проведения концерта Энрике Иглесиаса.
                    2.2. Определение победителя случайным образом: 8 сентября 2026 года.
                    2.3. Объявление результатов и передача приза: в период с 6 сентября по 26 сентября 2026 года.

                    <b>3. Территория проведения</b>

                    3.1. Активация проводится на территории Республики Казахстан, в VIP-лаунже на площадке проведения концерта Энрике Иглесиаса. Участвовать могут только лица, постоянно проживающие в РК.

                    <b>4. Участники Активации</b>

                    4.1. К участию допускаются дееспособные физические лица, достигшие 21 (двадцати одного) года на дату регистрации.
                    4.2. Не могут участвовать сотрудники Организатора, аффилированных компаний, агентств, задействованных в организации Активации, и их близкие родственники.
                    4.3. Регистрируясь у Хостес, участник подтверждает, что достиг указанного возраста и относится к употреблению алкоголя ответственно.
                    4.4. К участию допускаются только гости, имеющие право доступа в VIP-лаунж Chivas Regal на площадке проведения концерта.

                    <b>5. Условия и порядок участия</b>

                    5.1. Для участия в Активации в течение дня, указанного в п. 2.1, участнику необходимо обратиться к Хостес в VIP-лаунже Chivas Regal и заполнить анкету участника, указав следующие данные:
                    - имя;
                    - e-mail;
                    - номер телефона;
                    - аккаунт в Instagram;
                    - пол;
                    - город;
                    - предпочитаемый вид Chivas Regal.
                    5.2. Участник подтверждает достоверность указанных данных и даёт согласие на обработку персональных данных в целях проведения Активации.
                    5.3. Один участник — одна анкета. Повторные анкеты от одного и того же участника (по номеру телефона / e-mail / аккаунту Instagram) не учитываются.
                    5.4. Организатор вправе не учитывать анкеты с неполными, недостоверными или некорректными данными, а также заполненные лицами, не соответствующими условиям п. 4.1.

                    <b>6. Призовой фонд</b>

                    6.1. Призовой фонд Активации: 1 (одна) бутылка Chivas Regal 16 YO Charles Leclerc и 1 (одна) кепка Scuderia Ferrari × Chivas Regal.
                    6.2. Количество победителей: 1 (один). Оба предмета призового фонда передаются одному победителю.
                    6.3. Приз не подлежит замене на денежный эквивалент и передаче третьим лицам без согласования с Организатором.

                    <b>7. Порядок определения победителя</b>

                    7.1. Победитель определяется случайным образом из числа всех участников, заполнивших анкету в порядке, установленном п. 5.1, в течение дня проведения Активации (п. 2.1).
                    7.2. Определение победителя проводится 8 сентября 2026 года.
                    7.3. Организатор связывается с победителем по контактным данным, указанным в анкете, в течение 5 (пяти) рабочих дней.
                    7.4. Если победитель не выходит на связь в течение 5 (пяти) дней с момента первой попытки связаться, Организатор вправе определить другого победителя.

                    <b>8. Прочие условия</b>

                    8.1. Организатор вправе вносить изменения в настоящие Условия, включая сроки Активации.
                    8.2. Факт заполнения анкеты у Хостес означает полное согласие участника с настоящими Условиями.`,
                }
            },
            config: {
                ...config,

                // bgLogoMainMobile: require(`@/assets/img/${config.bgLogoMainMobile}`),
                // bgLogoMain: require(`@/assets/img/${config.bgLogoMain}`),
                // logoMain: require(`@/assets/img/${config.logoMain}`),
                // logoMainMobile: require(`@/assets/img/${config.logoMainMobile}`),
                // logoInvisible: require(`@/assets/img/${config.logoInvisible}`),
                // bigImage: require(`@/assets/img/${config.bigImage}`),
                // bigImageMobile: require(`@/assets/img/${config.bigImageMobile}`),
                // footer: {
                //     ...config.footer,
                //     logoMainFooter: require(`@/assets/img/${config.footer.logoMainFooter}`),
                //     logoMainMobileFooter: require(`@/assets/img/${config.footer.logoMainMobileFooter}`),
                //     logo: require(`@/assets/img/${config.footer.logo}`),
                //     // Если есть другие картинки в футере — добавь их сюда
                // }
            }
        };
    },
    created() {
        if (localStorage.getItem("userAge") !== null) {
            this.showConfirm = false
        }
    },
    computed: {
        ...mapGetters(['getUserAge']),
        filteredQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type === 11 || q.type === 12));
        },
        normalQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type !== 11 && q.type !== 3 && q.type !== 12));
        }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        initLanding({
            brand: 'chivas_regal',
            activation: 'chivas_lounge_2026',
            landing_id: 'chivas-lounge-2026',
            landing_type: 'registration'
        });
        this.getFormFields();
    },
    watch: {
        formData: {
            deep: true,
            handler(val) {
                for (let [id, value] of Object.entries(val)) {
                    this.validateField(id, value);
                }
            }
        },
        getUserAge(newVal) {
            if (!newVal || !this.formSchema) return;

            const birthQuestion = this.formSchema.questions.find(q => q.type === 3);
            if (birthQuestion) {
                this.$set(this.formData, birthQuestion.id, newVal);
                console.log("NEW DATA");
            }
        }
    },
    methods: {
        onConfirmed() {
            this.showConfirm = false
            console.log("Компонент закрыт")
            // localStorage.setItem("ageConfirmed", "1")
        },
        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        //     onFinish (rsp) {
        //     this.loading = true
        //     setTimeout(() => {
        //       this.loading = false
        //       this.snackbarColor = (rsp === this.expectedOtp) ? 'success' : 'warning'

        //     }, 3500)
        //   },
        validateField(question) {
            const value = this.formData[question.id];
            let error = null;

            // Проверка только для текстовых полей (например id 1,2,7,4)
            if ([1, 2, 4, 5, 7, 10].includes(question.type)) {
                if (!value || value.trim() === "") {
                    error = "Поле обязательно";
                }
            }
            if ([11].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if ([12].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if (error === null) {
                if ([1].includes(question.type)) {
                    // Имя только буквы
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректное имя.";
                    }
                }

                if ([2].includes(question.type)) {
                    // Фамилия только буквы
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректную фамилию.";
                    }
                }

                if ([7].includes(question.type)) {
                    // Email
                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        error = "Введите корректный email.";
                    }
                }

                if ([4].includes(question.type)) {
                    // Телефон
                    if (!/^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value)) {
                        error = "Введите корректный номер телефона.";
                    }
                }

                // if ([10].includes(question.type)) {
                //     // Проверяем: если значения нет ИЛИ после удаления пробелов строка пустая
                //     if (!question.value || question.value.trim() === "") {
                //         error = "Введите логин Instagram";
                //     } else {
                //         error = ""; // Если всё ок, сбрасываем ошибку
                //     }
                // }
            }

            this.$set(this.errors, question.id, error);
        },
        markTouched(question) {
            trackFormStart('main_registration');
            this.$set(this.touched, question.id, true);
            this.validateField(question);
        },
        getPlaceholder(question, isMobile = false) {
            switch (question.type) {
                case 5:
                    return "Город";
                case 9:
                    // Если мобильная версия — новый текст, иначе стандартный
                    return isMobile ? "Какой Chivas вы предпочитаете" : "Продукт";
                case 10:
                    // Аналогично для логина
                    return isMobile ? "Ваш логин в Instagram" : "Введите логин";
                default:
                    return question.name;
            }
        },
        getFormFields() {
            this.isLoadingForm = true;
            this.formError = false;
            this.$http.get('/api/survey', {
                params: {
                    campaignId: "55784a6a-bca6-f111-b802-00155d79212a"
                }
            })
                .then(res => {
                    this.formSchema = res.data;
                    res.data.questions.forEach(q => {
                        if (q.type === 3) {
                            this.$set(this.formData, q.id, this.getUserAge);
                        } else {
                            this.$set(this.formData, q.id, "");
                        }
                    });
                })
                .catch(err => {
                    this.formError = true;
                    console.error("Ошибка загрузки формы", err);
                })
                .finally(() => {
                    this.isLoadingForm = false;
                });
        },
        submitForm() {
            console.log("Отправка формы:", this.formData);
            // пример отправки
            // this.$http.post("/api/survey/submit", this.formData)
        },
        openPopup(type) {
            this.currentPopup = type
            this.isPopupOpen = true
        },
        goTo(url) {
            window.open(url, '_blank'); // Откроется в новой вкладке
        },
        logCity() {
            console.log(this.city);
        },
        logNumber() {
            console.log(this.phone);
        },
        async sendVerificationCode() {
            const phoneQuestion = this.formSchema.questions.find(q => q.type === 4);
            if (!phoneQuestion) return;

            const phoneAnswerRaw = this.formData[phoneQuestion.id];
            const phoneAnswer = phoneAnswerRaw.replace(/[^\d+]/g, "");
            try {
                this.isSendSms = true; // Блокируем кнопку, пока идет проверка капчи
                await this.$recaptchaLoaded();
                const recaptchaToken = await this.$recaptcha('send_sms'); 
            // Готовим DTO
            const answerDto = {
                campaignId: "55784a6a-bca6-f111-b802-00155d79212a",
                surveyAnswer: {
                    surveyQuestionId: phoneQuestion.id,
                    answer: phoneAnswer
                },
                recaptchaToken: recaptchaToken,
            };
                console.log("Token:", recaptchaToken);
                console.log(answerDto);
                await this.$http.post("/api/Verification/SendCode", answerDto);
                console.log("Код отправлен!");
                this.otpErrorSms = false;
                return true;
            } catch (err) {
                console.error("Ошибка при отправке кода:", err);
                if (err?.response?.status === 409) {
                    // пользователь уже зарегистрирован
                    trackFormError({
                        formId: 'main_registration',
                        errorType: 'server',
                        fieldName: 'phone',
                        errorTextCode: 'phone_already_registered'
                    });
                    this.otpErrorSms = true;
                    this.showOtpPopup = true;
                    this.otpSuccess = false;
                    return false;
                }
                if (err?.response?.status === 403) {
                    // Бэкенд отбил запрос из-за низкого score капчи
                    trackFormError({
                        formId: 'main_registration',
                        errorType: 'captcha',
                        fieldName: 'recaptcha',
                        errorTextCode: 'captcha_rejected'
                    });
                    this.snackbar = true;
                    this.message = 'Подозрение на бота. Попробуйте перезагрузить страницу.';
                    return false;
                }
            } finally {
                this.isSendSms = false;
            }
        },
        async resendSms() {
            // можно просто вызвать sendVerificationCode ещё раз
            await this.startSmsTimer();
            await this.sendVerificationCode();
        },
        async confirmRegistration() {
            trackFormSubmit('main_registration');
            this.otpError = "";
            if (!this.formSchema) return;

            let hasErrors = false;
            if (Array.isArray(this.formSchema.questions)) {
                this.formSchema.questions.forEach(q => {
                    this.validateField(q);
                    const val = this.formData[q.id];
                    const err = this.errors[q.id];

                    let fieldName = 'field_' + q.id;
                    switch (q.type) {
                        case 1: fieldName = 'name'; break;
                        case 2: fieldName = 'surname'; break;
                        case 3: fieldName = 'birth_date'; break;
                        case 4: fieldName = 'phone'; break;
                        case 5: fieldName = 'city'; break;
                        case 7: fieldName = 'email'; break;
                        case 9: fieldName = 'product_choice'; break;
                        case 10: fieldName = 'instagram'; break;
                        case 11: fieldName = 'consent_personal_data'; break;
                        case 12: fieldName = 'consent_rules'; break;
                    }

                    const isEmpty = val === null || val === undefined || val === '' || ((q.type === 11 || q.type === 12) && val === false);

                    if (err || isEmpty) {
                        hasErrors = true;
                        let code = 'validation_error';
                        if (isEmpty) {
                            code = (q.type === 11 || q.type === 12) ? 'consent_required' : `${fieldName}_empty`;
                        } else if (q.type === 4) {
                            code = 'phone_invalid_format';
                        } else if (q.type === 7) {
                            code = 'email_invalid_format';
                        } else if (q.type === 1 || q.type === 2) {
                            code = `${fieldName}_invalid_format`;
                        }
                        trackFormError({
                            formId: 'main_registration',
                            errorType: 'validation',
                            fieldName,
                            errorTextCode: code
                        });
                    }
                });
            }

            if (hasErrors) {
                this.snackbar = true;
                this.message = 'Пожалуйста, заполните все обязательные поля корректно';
                return;
            }
            try {
                this.isSendSms = true;
                const isSent = await this.sendVerificationCode();
                if (isSent && !this.otpErrorSms) {
                    this.otpError = "";
                    this.otpSuccess = false;
                    this.showOtpPopup = true;
                    this.startSmsTimer();
                }
            } catch {
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
            } finally {
                this.isSendSms = false;
            }
        },
        async submitAnswersWithCode(code) {
            this.otpVerifying = true;
            this.otpError = "";
            this.otpSuccess = false;
            try {
                const payload = {
                    surveyId: this.formSchema.id,
                    campaignId: "55784a6a-bca6-f111-b802-00155d79212a",
                    verificationCode: code,
                    answers: Object.entries(this.formData).map(([key, value]) => {
                        let answer = String(value);

                        if (/^\+7[\d\s()-]{10,}$/.test(answer)) {
                            answer = answer.replace(/[^\d+]/g, '');
                        }

                        return {
                            surveyQuestionId: key,
                            answer
                        };
                    })
                };

                await this.$http.post('/api/AnswerSet', payload);
                this.otpSuccess = true;

                // Track successful registration and virtual page view
                const cityQuestion = this.formSchema?.questions?.find(q => q.type === 5);
                const productQuestion = this.formSchema?.questions?.find(q => q.type === 9);

                let cityName = '';
                if (cityQuestion && this.formData[cityQuestion.id]) {
                    const ans = (cityQuestion.answers || []).find(a => a.id === this.formData[cityQuestion.id]);
                    cityName = ans ? ans.name : String(this.formData[cityQuestion.id]);
                }

                let productName = '';
                if (productQuestion && this.formData[productQuestion.id]) {
                    const ans = (productQuestion.answers || []).find(a => a.id === this.formData[productQuestion.id]);
                    productName = ans ? ans.name : String(this.formData[productQuestion.id]);
                }

                trackRegistrationSuccess({
                    formId: 'main_registration',
                    city: cityName,
                    productChoice: productName
                });

                trackVirtualPageView('/chivaslounge/thank-you', 'Спасибо за регистрацию');

                this.formData = {};
            } catch (error) {
                console.error(error);
                const msg = error?.response?.data?.message || "Код введён неверно";
                this.otpError = msg;
                trackFormError({
                    formId: 'main_registration',
                    errorType: 'server',
                    fieldName: 'otp_code',
                    errorTextCode: 'otp_invalid_code'
                });
            } finally {
                this.otpVerifying = false;
            }
        },
        async startSmsTimer() {
            this.smsTimer = 60;
            if (this.smsTimerInterval) clearInterval(this.smsTimerInterval);
            this.smsTimerInterval = setInterval(() => {
                if (this.smsTimer > 0) {
                    this.smsTimer--;
                } else {
                    clearInterval(this.smsTimerInterval);
                    this.smsTimerInterval = null;
                    // Здесь можно вызвать метод компонента otp через $refs, если нужно
                }
            }, 1000);
        },
        onPhoneFocus(question) {
            trackFormStart('main_registration');
            if (!this.formData[question.id]) {
                this.$set(this.formData, question.id, '+7');
            }
        },
        onPhoneInput(question) {
            const val = this.formData[question.id] || '';
            if (!val.startsWith('+7')) {
                this.formData[question.id] = '+7' + val.replace(/\D/g, '').slice(1);
            }
            this.validateField(question);
        },
        closePopup() {
            this.showPopup = false;
            this.isPopupOpen = false; // Закрыть pop-up
            // Очистка полей
            this.phone = '';
            this.email = '';
            this.name = '';
            this.city = '';
            this.surname = '';
            this.checkbox = false;
        },
    }
}


</script>